<template>
  <div :load="doInit">
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <!-- <v-toolbar dense color="grey lighten-3" flat>
              <v-icon>mdi-file-document-box</v-icon>
              <v-toolbar-title>Motor Schedule</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn text icon color="primary" title="Load Report History" @click="viewRptHistory">
                <v-icon>mdi-archive</v-icon>
                <rpt-jobs-history title="Report History" id="motorSchedule" v-model="rptHistory" @close="doClose"></rpt-jobs-history>
              </v-btn>
            </v-toolbar> -->
            <v-card-title>
              <v-spacer></v-spacer>
              <v-btn color="primary" dark class="mb-2" @click="viewRptHistory">
                Load Report History
                <v-icon right dark>mdi-archive</v-icon>
                <rpt-jobs-history title="Report History" id="motorSchedule" v-model="rptHistory" @close="doClose"></rpt-jobs-history>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <message :messages="messages"></message>
              <form>
                <v-flex xs12>
                  <v-layout row wrap>
                    <v-flex xs12 md6>
                      <v-text-field :label="labels.customName" v-model="motorScheduleForm.customName" data-vv-name="customName" :data-vv-as="labels.customName"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6></v-flex>
                    <v-flex xs12 md6>
                      <v-text-field :label="labels.polNo" v-model="motorScheduleForm.polNo" :error-messages="errors.collect('motorScheduleForm.polNo')" v-validate="'required|entry|max:255'" data-vv-name="polNo" :data-vv-as="labels.polNo"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field :label="labels.renCnt" v-model="motorScheduleForm.renCnt" :error-messages="errors.collect('motorScheduleForm.renCnt')" v-validate="'required|integer|max:10'" data-vv-name="renCnt" :data-vv-as="labels.renCnt"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field :label="labels.endtCnt" v-model="motorScheduleForm.endtCnt" :error-messages="errors.collect('motorScheduleForm.endtCnt')" v-validate="'required|integer|max:10'" data-vv-name="endtCnt" :data-vv-as="labels.endtCnt"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field :label="labels.numberOfCopies" v-model="motorScheduleForm.numberOfCopies" :error-messages="errors.collect('motorScheduleForm.numberOfCopies')" v-validate="'required|integer|max:10'" data-vv-name="numberOfCopies" :data-vv-as="labels.numberOfCopies"></v-text-field>
                    </v-flex>
                    <v-flex lg6 xs12>
                      <v-checkbox v-model="motorScheduleForm.reprint" :label="labels.reprint" data-vv-name="reprint" :data-vv-as="labels.reprint"></v-checkbox>
                    </v-flex>
                    <v-flex lg6 xs12>
                      <v-checkbox v-model="motorScheduleForm.sendEmail" :label="labels.sendEmail" data-vv-name="sendEmail" :data-vv-as="labels.sendEmail"></v-checkbox>
                    </v-flex>
                    <v-flex xs12 class="pt-3">
                      <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
                        {{labels.export}}
                        <v-icon right dark>mdi-file-export</v-icon>
                      </v-btn>
                      <v-btn-toggle dense mandatory v-model="motorScheduleForm.format">
                        <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                          <span>{{format.label}}</span>
                          <v-icon :color="format.color">{{format.icon}}</v-icon>
                        </v-btn>
                      </v-btn-toggle>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import RptJobsHistory from '../shared/RptJobsHistory'

export default {
  data() {
    return {
      labels: {
        customName: 'Report Name',
        polNo: 'Policy No.*',
        endtCnt: 'Endorsement count*',
        renCnt: 'Renewal count*',
        numberOfCopies: 'Number of copies*',
        format: 'Export Format',
        // appID: 'Claim Type',
        // clmStatus: 'Status',
        export: 'Export to',
        sendEmail: 'Send Output to Email?',
        reprint: 'Reprint?'
      },
      motorScheduleForm: {
        customName: undefined,
        polNo: 'MPC18A00022000',
        endtCnt: 0,
        renCnt: 0,
        numberOfCopies: 1,
        // appID: undefined,
        // clmStatus: undefined,
        format: undefined,
        sendEmail: false,
        reprint: false
      },
      menu: {},
      appIDList: [],
      statusList: [],
      supportedFormat: [],
      submitting: false,
      rptHistory: false
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.scheduleReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    toDateValidation() {
      const result = 'required|from_to_date:' + this.reportForm.fromDate
      return result
    }
  },
  watch: {
    'supportedList': function (value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.motorScheduleForm.format = value[0].value
      }
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.scheduleReports.init !== 1) {
          await this.$store.dispatch('scheduleReportsInit')
        }
        const apiURI = this.rptMenu.motorSchedule
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
            // this.appIDList = data.appIDList
            // this.statusList = data.statusList
          }
        }
      } catch (err) {
        throw err
      }
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.motorScheduleForm)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    viewRptHistory() {
      this.rptHistory = true
    },
    doClose(rptKeys) {
      if (rptKeys !== undefined && rptKeys !== null) {
        JSON.parse(rptKeys, (key, value) => {
          if (key === 'fromDate') {
            this.reportForm.fromDate = new Date(value)
          } else if (key === 'toDate') {
            this.reportForm.toDate = new Date(value)
          } else if (key === 'appID') {
            this.reportForm.appID = value
          } else if (key === 'clmStatus') {
            this.reportForm.clmStatus = value
          } else if (key === 'format') {
            this.reportForm.format = value
          } else if (key === 'sendEmail') {
            this.reportForm.sendEmail = value
          }
        })
      }
      this.rptHistory = false
    }
  },
  async created() {
    this.doInit()
  },
  components: {
    RptJobsHistory
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style lang="scss">

</style>
